import React, {useState, useEffect, useRef} from 'react';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import ProtectedRoute from '../../../routes/protected';
import SideBarCompanyManagement from '../../../components/sidebars/sidebarCompanyManagement';
import companyService from '../../../services/data/company.service';
import { Steps } from 'primereact/steps';
import { Toast } from 'primereact/toast';
import currencies from './currencies.json';
import { Dropdown } from 'primereact/dropdown';
import FormAddCategory from '../../../components/settings/forms/formAddCategory';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { InputNumber } from 'primereact/inputnumber';
import currencyFormat from '../../../helpers/currencyFormat';
import * as Yup from 'yup';

const MIN_RANGES = 3;
const MAX_RANGES = 5;
const MIN_PERCENT = 80;
const MAX_PERCENT = 120;

function generateDefaultPercentages(count) {
    if (count <= 1) return [100];

    const percentages = Array.from({ length: count }, (_, i) => {
        const pct = MIN_PERCENT + (MAX_PERCENT - MIN_PERCENT) * i / (count - 1);
        return Math.round(pct * 100) / 100;
    });

    if (!percentages.some(p => p === 100)) {
        let closestIdx = 0;
        let closestDiff = Math.abs(percentages[0] - 100);
        percentages.forEach((p, i) => {
            const diff = Math.abs(p - 100);
            if (diff < closestDiff) {
                closestDiff = diff;
                closestIdx = i;
            }
        });
        percentages[closestIdx] = 100;
    }

    return percentages;
}

function generateDefaultRanges(count, baseAmount) {
    return generateDefaultPercentages(count).map(rangePercent => ({
        range: rangePercent,
        value: parseFloat(baseAmount * rangePercent / 100).toFixed(2)
    }));
}

function getBaseRangeIndex(ranges) {
    return ranges.findIndex(r => r.range === 100);
}


export default function CreatePayLevel() {

    const { id, grade_id } = useParams()
    const toast = useRef(null);
    const [payStructure, setPayStructure] = useState('')
    const [payGrade, setPayGrade] = useState('')
    const [selectedCurrency, setSelectedCurrency] = useState('')
    const [showCategory, setShowCategory] = useState(false)
    const [categoryList, setCategoryList] = useState('')
    const [amount, setAmount] = useState(
        parseFloat(1000, 2).toFixed(2)
    )
    const [currency, setCurrency] = useState('BRL')
    const [range, setRange] = useState([])
    const [itemsList, setItemsList] = useState([]);

    useEffect(() => {
        getPayStructure()
        getPayGrade()
        listCategories()
        setRange(generateDefaultRanges(MIN_RANGES, 1000))
        listItems()
    }, []);

    function listItems() {

        let plData = {
            company_id: localStorage.getItem("companyId"),
            structure_id: id,
            grade_id: grade_id
        }
        companyService.listPayLevel(plData).then((response) => {
            setItemsList(response)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    function getPayStructure() {
        companyService.getPayStructure(id).then((response) => {
            setPayStructure(response)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    function getPayGrade() {
        companyService.getPayGrade(grade_id).then((response) => {
            setPayGrade(response)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    function listCategories() {
        let _data = {
            company_id: localStorage.getItem("companyId"),
            model: 'paylevel'
        }
        companyService.listCategory(1, _data).then((response) => {
            setCategoryList(response.results)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    const handleShowCategory = () => {
        setShowCategory(!showCategory)
    }
    
    const stepItems = [
        {
            label: 'Estrutura'
        },
        {
            label: 'Nível'
        },
        {
            label: 'Salário'
        }
    ];

    function updateAmount(value) {
        setAmount(value)
        // update 100%
        rangeUpdateAll(value)
    }

    function rangeUpdateAll(value) {
        setRange(prevRange => prevRange.map(item => ({
            range: item.range,
            value: parseFloat(value * item.range / 100).toFixed(2)
        })));
    }

    function addRange() {
        if (range.length >= MAX_RANGES) return;
        setRange(generateDefaultRanges(range.length + 1, amount));
    }

    function removeRange() {
        if (range.length <= MIN_RANGES) return;
        setRange(generateDefaultRanges(range.length - 1, amount));
    }

    function rangePercent(value1, value2) {
        return value1/value2*100
    }

    // para update de 80% e 120%
    function rangeUpdate(value, index) {

        const newPerct = rangePercent(parseFloat(value, 2), amount)

        const newRange = range.map((item, i) => {
            if (index === i) {
                // Update

                if (item.range === 100) {
                    return {
                        range: 100,
                        value: parseFloat(value, 2).toFixed(2)
                    }
                }
                return {
                    range: newPerct,
                    value: parseFloat(value, 2).toFixed(2)
                }
            } else {
                return item;
            }
        })
        setRange(newRange)
    }

    //update via percent
    function percentUpdate(value, index) {

        const newRange_ = range.map((item, i) => {
            if (index === i) {
                // Update
                return {
                    range: value,
                    value: parseFloat(amount * value / 100).toFixed(2)
                }
            } else {
                return item;
            }
        })
        setRange(newRange_)
    }

    const formik = useFormik({
        initialValues: {
            title: '',
            currency: '',
            frequency: '',
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Campo Título é obrigatório"),
            currency: Yup.string().required("Campo Moeda é obrigatório"),
            frequency: Yup.string().required("Campo Frequência é obrigatório"),
            //amount: Yup.string().required("Campo Valor é obrigatório"),
        }),
        onSubmit: values => {

            let data = {
                company_id: localStorage.getItem("companyId"),
                title: values.title,
                structure_id: id,
                grade_id: grade_id,
                currency: values.currency,
                frequency: values.frequency,
                amount: amount,
                range: range
            }

            companyService.createPayLevel(data).then(() => {
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Salário adicionado com sucesso', life: 3000 });
                listItems()
                //formik.resetForm()

            }).catch((error) => {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data, life: 4000 });
            });

        }
    });

    return (
        <ProtectedRoute>

            <Toast ref={toast} position="top-right" />

            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SideBarCompanyManagement />
                    <div className="col p-0 formMarginBottom">
                        <div className='text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Estrutura de Salários</span>
                        </div>
                        <div className="row justify-content-center mt-5">
                            <div className='col-xl-6'>
                                <Steps model={stepItems} activeIndex={2} />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className='col-12'>
                                <a href={`/settings/salary-structure/management/${id}/detail/`} className="nav-link my-3">
                                    <span className="text-green fw-bold"><FontAwesomeIcon icon={solid('chevron-left')} /> Voltar</span>
                                </a>
                            </div>
                            <div className='col-5'>
                                <div className="p-3 bg-white rounded border-clean">
                                    <span className='font120 fw-bold'>
                                        Adicionar Salário(s)
                                    </span>
                                    <form onSubmit={formik.handleSubmit}>

                                        <table className='table table-bordered mt-2 alert-warning border'>
                                            <thead>
                                                <tr className='text-center'>
                                                    <th>
                                                    Estrutura
                                                    </th>
                                                    <th>
                                                    Nível
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className='text-center'>
                                                    <td>
                                                        {payStructure.title}
                                                    </td>
                                                    <td>
                                                        {payGrade.title}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className='mb-3'>
                                            <label className="form-label fw-bold">Título <span className="text-danger">*</span></label>
                                            <input name="title" className='form-control' required {...formik.getFieldProps('title')} />
                                            {formik.errors.title ? (<span name="title" className="text-vermelho">{formik.errors.title}</span>) : null}
                                        </div>

                                        <div className="row p-0 my-3">
                                            <div>
                                                <label className="form-label fw-bold">Frequência <span className="text-danger">*</span></label>
                                                <button className="btn btn-sm" onClick={(e) => handleShowCategory(e)}>
                                                    <FontAwesomeIcon className='text-green font150' icon={solid('plus-circle')} />
                                                </button>
                                            </div>
                                            {
                                                showCategory ?
                                                <>
                                                <div className='my-3 bg-light'>
                                                    <FormAddCategory model='paylevel' listCategories={listCategories} handleShowCategory={handleShowCategory} />
                                                </div>
                                                <hr/>
                                                </>
                                                :
                                                null
                                            }
                                            <div className='col-md-8'>
                                            {
                                                categoryList ?
                                                <select className='form-select col-md-4' required {...formik.getFieldProps('frequency')}>
                                                    <option value=''>Selecionar</option>
                                                    {
                                                        categoryList.map((item, index) =>
                                                        <option key={index} value={item.id}>{item.title}</option>
                                                        )
                                                    }
                                                </select>
                                                :
                                                null
                                            }
                                            {formik.errors.frequency ? (<span name="frequency" className="text-vermelho">{formik.errors.frequency}</span>) : null}
                                            </div>
                                        </div>

                                        <div className='mt-3 row p-0'>
                                            <div className='col'>
                                                <label className="form-label fw-bold">
                                                    Moeda <span className="text-danger">*</span>
                                                </label>
                                                <div className='p-inputgroup'>
                                                    <Dropdown filter placeholder="Selecionar" value={selectedCurrency} optionLabel="code" options={currencies} onChange={(e) => {setSelectedCurrency(e.value); setCurrency(e.value.code); formik.setFieldValue('currency', e.value.code);} } className="rounded" />
                                                </div>
                                                {formik.errors.currency ? (<span name="currency" className="text-vermelho">{formik.errors.currency}</span>) : null}
                                            </div>

                                            <div className='col'>
                                                <label className="form-label fw-bold">
                                                    Valor Base <span className="text-danger">*</span>
                                                </label>
                                                <div className='p-inputgroup'>
                                                    <InputNumber mode="currency" currency={currency} value={amount} onValueChange={(e) => {updateAmount(e.value)}} className="rounded" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='mt-3 col'>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <label className="form-label fw-bold mb-0">
                                                    Faixa Salarial <span className="text-danger">*</span>
                                                </label>
                                            </div>
                                            <div className="btn-group" style={{marginBottom: '0.775rem'}}>
                                                    <button type="button" className="btn btn-sm btn-outline-success" style={{fontSize: '0.775rem'}} onClick={removeRange} disabled={range.length <= MIN_RANGES} title="Remover faixa">
                                                        <FontAwesomeIcon icon={solid('minus')} /> Faixa
                                                    </button>
                                                    <button type="button" className="btn btn-sm btn-outline-success" style={{fontSize: '0.775rem'}} onClick={addRange} disabled={range.length >= MAX_RANGES} title="Adicionar faixa">
                                                        <FontAwesomeIcon icon={solid('plus')} /> Faixa
                                                    </button>
                                                </div>
                                            <small className="text-muted d-block mb-2">{range.length} faixas ({MIN_PERCENT}% a {MAX_PERCENT}%)</small>
                                            <table className='table table-bordered'>
                                                <thead>
                                                    <tr>
                                                    {
                                                        range.map((item, index) => {
                                                            const isBaseRange = index === getBaseRangeIndex(range);
                                                            return (
                                                            <th key={index} className="text-center text-default">
                                                                {
                                                                    !isBaseRange ?
                                                                    <div className='p-inputgroup'>
                                                                        <InputNumber inputClassName="text-center" value={item.range} suffix="%" onValueChange={(e) => {percentUpdate(e.value, index)}} className="rounded" />
                                                                    </div>
                                                                    :
                                                                    <div className='p-inputgroup'>
                                                                        <InputNumber inputClassName="text-center" disabled suffix="%" value={item.range} className="rounded" />
                                                                    </div>
                                                                }
                                                            </th>
                                                            );
                                                        })
                                                    }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                    {
                                                        range.map((item, index) => {
                                                            const isBaseRange = index === getBaseRangeIndex(range);
                                                            return (
                                                            <td key={index}>
                                                                <div className='p-inputgroup'>
                                                                    {
                                                                        isBaseRange ?
                                                                        <InputNumber inputClassName="text-center" mode="currency" currency={currency} disabled value={item.value} className="rounded" />
                                                                        :
                                                                        <InputNumber inputClassName="text-center" mode="currency" currency={currency} value={item.value} onValueChange={(e) => {rangeUpdate(e.value, index)}} className="rounded" />
                                                                    }
                                                                </div>
                                                            </td>
                                                            );
                                                        })
                                                    }
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="d-grid mx-auto btnMargin">
                                            <button className="btn btn-success btn-sm btn-rounded" type="submit">
                                                Adicionar
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            </div>

                            <div className='col-7'>
                                <div className="p-3 bg-white rounded border-clean">
                                    <p><strong>{itemsList && itemsList.results ? itemsList.results.length : 0}</strong> Salários cadastrados</p>
                                    {
                                        itemsList && itemsList.results && itemsList.results.length > 0 ?
                                        <>
                                        <table className='table table-borderless thover borderBottom mt-3'>
                                            <thead className='borderBottom'>
                                                <tr>
                                                    <th className='text-center'>
                                                        Salários
                                                    </th>
                                                    <th className='text-center'>
                                                        Moeda
                                                    </th>
                                                    <th className='text-center'>
                                                        Frequência
                                                    </th>
                                                    <th className='text-center'>
                                                        Faixa Salarial
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    itemsList.results.map((item, index) =>
                                                        <tr key={index}>
                                                            <td className="align-middle text-center">
                                                                {item.title}
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                {item.currency}
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                {item.frequency}
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                <table className='table table-bordered'>
                                                                    <thead>
                                                                        <tr>
                                                                        {
                                                                            item.range.map((item, index) => 
                                                                                <th key={index} className="text-center">
                                                                                    {item.range}%
                                                                                </th>
                                                                            )
                                                                        }
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                        {
                                                                            item.range.map((item, index) => 
                                                                                <td key={index}>
                                                                                    {currencyFormat(item.value)}
                                                                                </td>
                                                                            )
                                                                        }
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                        </>
                                        : null
                                    }
                                </div>
                            </div>
                                
                        </div>
                    </div>
                </div>
            </div>

        </ProtectedRoute>
    )
}